// eslint-disable-next-line no-shadow
export enum RateCategory {
    Compact = 1,
    MidSize = 2,
    FullSize = 3,
    HeavyDuty = 4
}
